import { render, staticRenderFns } from "./theader.vue?vue&type=template&id=0df1e0e6&scoped=true"
import script from "./theader.vue?vue&type=script&lang=js"
export * from "./theader.vue?vue&type=script&lang=js"
import style0 from "./theader.vue?vue&type=style&index=0&id=0df1e0e6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df1e0e6",
  null
  
)

export default component.exports